module.exports = __webpack_public_path__ + "img/ico.e243eb14.png";